export default "__VITE_ASSET__5b0f152e__$_?component__"